import React from 'react'

export const PrivateTitleBar = (props) => {
    return (
        <>
            {/* TODO: SACAR A COMPONENTE TITLEBAR Y FOOTER EN LA PARTE PRIVADA */}
            {/* <!-- Titlebar --> */}
            <div id="titlebar">
                <div className="row">
                    <div className="col-md-12">
                        <h2>{props.title}</h2>
                    </div>
                </div>
            </div>
        </>
    )
}